<template>
    <div class="q-pa-md">
        <div class="q-display-1 q-mb-md text-secondary">
            <q-icon name="far fa-desktop" class="q-mb-sm" /> {{ $t('banners_campaigns') }}
        </div>

        <div class="row gutter-sm">
            <div class="col-xs-12 col-sm-12">
                <q-input v-model="title" :float-label="$t('title')" :error="$v.title.$error" @input="$v.title.$touch" />
            </div>

            <div class="col-xs-12 col-sm-12">
                <q-input v-model="description" :float-label="$t('description')" :error="$v.description.$error" @input="$v.description.$touch" />
            </div>

            <div class="col-xs-12 col-sm-12">
                <q-input v-model="button_label" :float-label="$t('button_label')" :error="$v.button_label.$error" @input="$v.button_label.$touch" />
            </div>

            <div class="col-xs-12 col-sm-12">
                <q-input v-model="url" :float-label="$t('url')" :error="$v.url.$error" @input="$v.url.$touch" />
            </div>

            <div class="col-xs-12 col-sm-12">
                <p class="caption">{{ $t('image') }}</p>

                <uploader content_type="images" @fileUploaded="imageDesktopUploaded" :multiple="false" :cropper="false" :aspect_ratio="192/40" :aspect_ratio_string="'192/40'" :error="$v.image.$error" @input="$v.image.$touch" />

                <p v-if="image" class="q-mt-md file-url">
                    <q-icon name="fal fa-check" color="positive" />
                    <a :href="image" target="_blank"> {{ $truncateLink(image) }}</a>
                </p>
            </div>

            <div class="col-xs-12 col-sm-6">
                <q-datetime v-model="publish_date" type="date" :float-label="$t('publish_date')" format="DD/MM/YYYY" clearable :error="$v.publish_date.$error" @input="$v.publish_date.$touch" />
            </div>

            <div class="col-xs-12 col-sm-6">
                <q-datetime v-model="unpublish_date" type="date" :float-label="$t('unpublish_date')" format="DD/MM/YYYY" clearable :error="$v.unpublish_date.$error" @input="$v.unpublish_date.$touch" />
            </div>

             <div class="col-xs-12 col-sm-12">
                <q-tabs v-model="tab" color="secondary" class="shadow-1">
                    <q-tab slot="title" name="permissions" icon="fal fa-clipboard-list-check" :label="$t('permissions')" />

                    <q-tab-pane name="permissions" class="q-px-lg q-pb-xl">
                        <div class="row gutter-sm">
                            <div class="col-xs-12 col-sm-12">
                                <q-select filter autofocus-filter v-model="area" :options="areas" :float-label="$t('areas')" :error="$v.area.$error" @input="$v.area.$touch" multiple chips />
                            </div>

                            <div class="col-xs-12 col-sm-12">
                                <p class="caption">{{ $t('profiles') }}</p>

                                <div class="row gutter-sm">
                                    <div class="col-xs-12 col-sm-12">
                                        <q-checkbox v-model="all_profiles" :val="true" :label="$t('all')" @input="checkAll()" />
                                    </div>

                                    <div class="col-xs-12 col-sm-4" v-for="(item, index) in profiles" :key="index" :class="getErrorClass($v.profile.$error)">
                                        <q-checkbox keep-color v-model="profile" :val="item.value" :label="item.label" @input="$v.profile.$touch" :color="getErrorColor($v.profile.$error)" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </q-tab-pane>
                </q-tabs>
            </div>

            <div class="col-xs-12 col-sm-12">
                <p class="caption">{{ $t('status') }}</p>
                <q-btn-toggle v-model="status" :toggle-color="getColorStatus" :options="statuses" />
            </div>
        </div>

        <div class="row gutter-sm justify-end q-mt-lg">
            <div class="col-xs-12 col-sm-3" :class="getOrder('cancel')">
                <q-btn color="tertiary" class="full-width" :label="$t('back')" icon="far fa-chevron-left" @click="$router.push({ name: 'banners_campaign' })" />
            </div>

            <div class="col-xs-12 col-sm-3" :class="getOrder('save')">
                <q-btn color="secondary" class="full-width" :label="$t('save')" icon="far fa-save" @click="saveData()" />
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { required, requiredIf } from 'vuelidate/lib/validators'
import Uploader from 'components/Uploader'
import { date } from 'quasar'

export default {
    i18nOptions: { namespaces: [ "custom", "common", "training", "admin", "banners" ] },

    components: {
        'uploader': Uploader
    },

    data() {
        return {
            id_banner: '',
            title: '',
            description: '',
            button_label: '',
            area: [],
            profile: [],
            url: '',
            image: '',
            publish_date: '',
            unpublish_date: '',
            status: 1,
            tab: 'permissions',
            statuses: [
                { label: this.$t('active_f'), value: 1 },
                { label: this.$t('inactive_f'), value: 2 }
            ],
            all_profiles: false,
            profile_loaded: false,
        }
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token',
            areas: 'registration_lists/country_areas',
            profiles: 'registration_lists/profiles',
            area_countries: 'registration_lists/country_areas'
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },

        disableFields() {
            if (this.status === 2 || this.status === 3 ) {
                return true
            }
            else return false
        },

        getColorStatus() {
            if (this.status == 1) return 'positive'
            else return 'warning'
        },
    },

    methods: {
        fetchData() {
            this.$axios.get('/admin_banners/banners_campaign/' + this.id_banner + '/', this.getHeader)
            .then(response => {
                this.title = response.data.title
                this.status = response.data.status
                this.description = response.data.description
                this.button_label = response.data.button_label
                this.url = response.data.url
                this.image = response.data.image
                this.publish_date = response.data.publish_date
                this.unpublish_date = response.data.unpublish_date
                response.data.areas.forEach((area, index) => {
                    this.area.push(area)
                })
                response.data.profiles.forEach((profile, index) => {
                    this.profile.push(profile)
                })
                this.$q.loading.hide()
            })
            .catch(e => {
                this.$q.loading.hide()
                console.log(e)
            })
        },

        saveData() {
            this.$v.$touch()

            if (!this.$v.$error) {
                this.$q.loading.show()

                let data ={
                    title: this.title,
                    description: this.description,
                    button_label: this.button_label,
                    url: this.url,
                    profiles: this.profile,
                    areas: this.area,
                    image: this.image,
                    status: this.status,
                    publish_date: this.publish_date,
                    unpublish_date: this.unpublish_date
                }

                if (this.publish_date) data.publish_date = date.formatDate(this.publish_date, 'YYYY-MM-DD')
                if (this.unpublish_date) data.unpublish_date = date.formatDate(this.unpublish_date, 'YYYY-MM-DD')

                if (this.id_banner != 0) {
                    this.$axios.put('/admin_banners/banners_campaign/' + this.id_banner + '/', data, this.getHeader)
                    .then(response => {
                        this.$q.loading.hide()
                        this.$router.push({ name: 'banners_campaign' })
                    })
                    .catch(e => {
                        this.$q.loading.hide()
                        console.log(e)
                    })
                }
                else {
                    this.$axios.post('/admin_banners/banners_campaign/', data, this.getHeader)
                    .then(response => {
                        this.$q.loading.hide()
                        this.$router.push({ name: 'banners_campaign' })
                    })
                    .catch(e => {
                        this.$q.loading.hide()
                        console.log(e)
                    })
                }
            }
            else {
                this.$q.notify({
                    message: this.$t('make_sure_that_all_fields_are_filled_in'),
                    type: 'negative',
                    icon: 'fal fa-exclamation-triangle',
                    position: 'top'
                })
            }
        },

        getOrder(name) {
            if (name == 'cancel') {
                if (this.$q.platform.is.mobile) return 'order-last'
                else return 'order-first'
            }
            else if (name == 'save') {
                if (this.$q.platform.is.mobile) return 'order-first'
                else return 'order-last'
            }
        },

        checkAll() {
            if (this.all_profiles) {
                this.profiles.forEach(element => {
                    this.profile.push(element.value)
                })
            }
            else {
                this.profile = []
            }
        },

        imageDesktopUploaded(url) {
            this.image = url
        },

        getErrorClass(state) {
            if (state) return 'checkbox-error'
            else return ''
        },

        getErrorColor(state) {
            if (state) return 'negative'
            else return ''
        },

        getErrorClass(state) {
            if (state) return 'checkbox-error'
            else return ''
        },
    },

    created() {
        this.id_banner = this.$route.params.id
        if (this.id_banner != 0) this.fetchData()
    },

    validations() {
        return {
            title: { required },
            description: { required },
            button_label: { required },
            area: {
                requiredIf: requiredIf(() => {
                    return this.tab == 'permissions' ? true : false
                })
            },
            profile: {
                requiredIf: requiredIf(() => {
                    return this.tab == 'permissions' ? true : false
                })
            },
            url: { required },
            image: { required },
            publish_date: { required },
            unpublish_date: { required },
        }
    }
}
</script>

<style>

</style>
